import { strongPassword } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { accountService } from '@/services/account';
import { useVuelidate } from '@vuelidate/core';
import { email, helpers, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useProfile() {
    const crudAction = useCrudActions();

    const model = reactive({
        firstname: '',
        lastname: '',
        email: '',
        oldPassword: '',
        password: '',
        repassword: ''
    });

    const validations = {
        firstname: { required },
        lastname: { required },
        email: { required, email },
        oldPassword: { required },
        password: { strongPassword },
        repassword: {
            required,
            validValue: helpers.withMessage('Passwords do not match', (value: any) => value === model.password)
        }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: accountService.get,
        onSuccess: ({ data }) => Object.assign(model, data)
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                accountService.update(model.firstname, model.lastname, model.email, model.password, model.oldPassword),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
